module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Sammi_CR-p-500-d48990cc277df8b77542944f2fc63106.jpg";